import classnames from 'classnames'
import React from 'react'
import {
  IProps as ITestimonialMiniCardProps,
  TestimonialMiniCard,
} from '../../elements/TestimonialMiniCard'
import { containerMaxWidth, gridGap, mq, LegacyColor, getColorTheme } from '../../utils'
import { IProps } from './index'
import { MagicLine } from '../MagicLine'
import { BrandOptions, useBrand } from '../../providers/brandProvider'
import { TestimonialMini as TestimonialMiniDefault } from './component'

export function TestimonialMini(props: IProps) {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <TestimonialMiniDefault {...props} />
  }
  return <TestimonialMiniLegacy {...props} />
}

export class TestimonialMiniLegacy extends React.PureComponent<IProps> {
  getListItem(data: ITestimonialMiniCardProps, index: number, oddTotal: boolean) {
    return (
      <li key={index}>
        <TestimonialMiniCard {...data} />
        <style jsx>
          {`
            li {
              max-width: 400px;
              margin: 0 auto;
              grid-row: ${oddTotal ? index + 1 : 'auto'} / span 2;
            }
          `}
        </style>
      </li>
    )
  }

  render() {
    const { testimonials, bgColor, withMagicSparkles } = this.props
    const isFullWidth = !!bgColor

    const oddTotal = testimonials.length % 2 === 1
    const listClasses = classnames({
      cards: true,
      multiple: testimonials.length > 1,
      single: testimonials.length === 1,
      fullwidth: isFullWidth,
    })

    const colorTheme = bgColor && getColorTheme('legacy', bgColor)

    return (
      <>
        <div
          className={classnames('testimonial-mini testimonial-mini-theme', {
            'testimonial-mini-full-width': isFullWidth,
          })}
        >
          <ul className={listClasses}>
            {testimonials &&
              testimonials.map((testimonial, index) => {
                return this.getListItem(testimonial, index, oddTotal)
              })}
          </ul>

          <style jsx>{`
            .testimonial-mini-theme {
              background-color: ${colorTheme?.backgroundColor || LegacyColor.White};
              color: ${colorTheme?.textColor || LegacyColor.Black};
            }

            .testimonial-mini.testimonial-mini-full-width {
              margin-bottom: -80px;
              z-index: -1;
              max-width: 100%;
              padding: 50px 0;
            }
          `}</style>

          <style jsx>
            {`
              .testimonial-mini {
                display: grid;
                grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
                max-width: ${containerMaxWidth};
                grid-column-gap: ${gridGap.mobile};
                margin: 0 auto;
                position: relative;
              }

              .cards {
                grid-column: content;
                z-index: 2;
              }

              .cards.fullwidth {
                max-width: ${containerMaxWidth};
                margin: 0 auto;
              }

              @media (${mq.tablet}) {
                .testimonial-mini {
                  grid-column-gap: ${gridGap.desktop};
                  padding: 50px 0;
                }

                .cards {
                  grid-column: content;
                  display: grid;
                }

                .multiple {
                  grid-template-columns: [left] 1fr [right] 1fr;
                  grid-column-gap: 10%;
                  grid-template-rows: auto;
                }

                .single {
                  display: grid;
                  grid-template-columns: [content] 40%;
                  justify-content: center;
                }
              }
              @media (${mq.desktopLg}) {
                .testimonial-mini {
                  grid-template-columns: [left-gutter] 2fr [content] 10fr [right-gutter] 2fr;
                }
              }
            `}
          </style>
        </div>
        {withMagicSparkles && <MagicLine texture="sparkle-left" />}
      </>
    )
  }
}
